export class Enlace {
    codigo: number;
    nombre1: string;
    nombre2: string;
    link1: string;
    link2: string;
    imagen: any;
    activo: boolean;
}